export default function Agencias() {
    return (
        <>
            <section id="portfolio" className="portfolio section light-background">
                <div className="container section-title" data-aos="fade-up">
                    <div>
                        <span> Para Agências</span> <span className="description-title">(White-label) </span>
                    </div>
                </div>

                <div className="py-lg-16 py-10 bg-gray-200">
                    <div className="offset-lg-2 col-lg-8 col-md-12 col-12 text-center">
                        <h2 className="display-3 mt-4 mb-3  fw-bold">Precisa de ajuda?</h2>

                        <p className="lead  px-lg-8 mb-6">
                            Atuamos como parceiro white-label em desenvolvimento e DevOps, integrando ao seu processo e
                            ferramentas, com acordo de confidencialidade.
                        </p>

                        {/*<a href="#" class="btn btn-primary p-3">Solicitar ajuda</a>*/}
                    </div>
                </div>
            </section>
        </>
    );
}
